/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createGetMatrixDataType } from '../../factoriesAny.js';
export var getMatrixDataTypeDependencies = {
  typedDependencies: typedDependencies,
  createGetMatrixDataType: createGetMatrixDataType
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesGetMatrixDataType.generated.js
// module id = 1418
// module chunks = 0